import { useEffect, useState } from "react";
import SupplierResponseView from "../Components/SupplierResponseView";
import { ApiHandler } from "../../Constants/ApiHandler";
import { NotificationManager } from "react-notifications";
import { commonParentCompProps } from "../../commonParentCompPropsTypes";
import { useParams } from "react-router-dom";
import { commonProps } from ".././../commonTypes";
import { Notify } from "../../Common/Notify/NotificationMessages";
import { useImmer } from "use-immer";
function SupplierResponseViewContainer() {
  const { id } = useParams() as { id: string };
  const surveyAnswerDocId: string = id;
  //state-mainatined-for-all-supplier-and-survey-infos
  const [surveyAnswersInfo, setSurveyAnswersInfo] = useState<
    commonParentCompProps["surveyAnswersInfo"]
  >({} as commonParentCompProps["surveyAnswersInfo"]);
  //state-maintained-for-answered-questions
  const [surveyAnswers, setSurveyAnswers] = useImmer<
    commonParentCompProps["surveyAnswers"]
  >({} as commonParentCompProps["surveyAnswers"]);
  //state-maintained-for-keep-an-constant-variable-for-questionObj
  const [questionObjVariable, setQuestionObjVariable] = useState(
    {} as commonProps["Question"]["questionObj"]
  );

  //get-surveyAnswers
  useEffect(() => {
    if (surveyAnswerDocId) {
      (async () => {
        try {
          const response = await ApiHandler.getAnswer(surveyAnswerDocId);
          setSurveyAnswersInfo({ ...response.results });
          setSurveyAnswers({ ...response.results.surveyAnswers });
          setQuestionObjVariable({
            ...response?.results?.surveyInfo?.questionsInfo?.questionObj,
          });
        } catch (error) {
          NotificationManager.warning(Notify.DEFAULT, "", 2000);
        }
      })();
    }
  }, [surveyAnswerDocId]);

  return (
    <SupplierResponseView
      surveyAnswersInfo={surveyAnswersInfo}
      setSurveyAnswersInfo={setSurveyAnswersInfo}
      surveyAnswers={surveyAnswers}
      setSurveyAnswers={setSurveyAnswers}
      questionObjVariable={questionObjVariable}
      surveyAnswerDocId={surveyAnswerDocId}
    />
  );
}
export default SupplierResponseViewContainer;
